<div class="form-material input-group" style="padding-top:0px;">
  <input placeholder="MM/DD/YYYY" matInput (keyup)="dateTextChange($event)" (blur)="dateTextBlur($event)" [ngModel]="calendarSvc.targetDate | date:'MM/dd/yyyy'"  >
  <BR>

  <!--
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
  -->
</div>

<div (click)="forceDropdownOpen($event)">
  <!-- {{calendarSvc.targetDate?.toISOString()}} -->
  <mat-calendar (selectedChange)="onChange($event)" (click)="calendarClicked($event)"  [selected]="calendarSvc.targetDate" [startAt]="tDate" ></mat-calendar>
</div>
 